import React from 'react';

import { TooltipContainer, Tooltip } from './TooltipV2.styles';

export type TooltipV2Prop = {
  className?: string;
  popIn?: boolean;
  text?: string | JSX.Element;
};

/**
 * TooltipV2Prop
 *
 * @param {string} className class name of parent element. prefer overriding styles with Emotion
 * @param {boolean} popIn  show/hide the tooltip
 * @param {string | JSX.Element} text text content of the tooltip. can pass JSX if inner content needs to be complex
 */
const TooltipV2: React.FC<TooltipV2Prop> = ({ className, popIn, text }) => (
  <TooltipContainer className={className} data-testid="TooltipV2">
    <Tooltip popIn={popIn}>{text}</Tooltip>
  </TooltipContainer>
);

export default TooltipV2;
